import { Backdrop, CircularProgress, Snackbar, styled as muiStyled } from "@mui/material";
import { useRecoilState } from "recoil";
import { globalLoadingSnackbarStateSelector, globalLoadingStack } from "../state";

const BootstrapSnackbar = muiStyled(Snackbar)(({ theme }) => ({
	"> div": {
		background: "transparent",
		boxShadow: "none",
		fontWeight: "bold",
		textAlign: "center",
		width: "100%",
	},
	"> div > div": {
		background: "transparent",
		boxShadow: "none",
		fontWeight: "bold",
		textAlign: "center",
		width: "100%",
		fontSize: "20px",
		whiteSpace: "pre-wrap",
	},
}));

const GlobalLoding = () => {
	const [loadingStack, _] = useRecoilState(globalLoadingStack);
	const [snackbarState, setSnackbareState] = useRecoilState(globalLoadingSnackbarStateSelector);

	if (loadingStack <= 0) return null;

	return (
		<Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={loadingStack > 0}>
			<CircularProgress color="inherit" />
			<BootstrapSnackbar
				anchorOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				open={true}
				message={snackbarState}
				sx={{
					zIndex: 9999,
				}}
				style={{
					top: "35%",
				}}
			/>
		</Backdrop>
	);
};

export default GlobalLoding;
